import {Pipe, PipeTransform} from '@angular/core';
import {productCategories} from '@app/product-group-select/product-group-select.component';

@Pipe({
  name: 'productGroupTranslate',
  standalone: true,
})
export class ProductGroupTranslate implements PipeTransform {
  transform(val: string): string {
    let retVal;
    productCategories.forEach((group) => {
      group.productGroups.forEach((x) => {
        if (x.value === val) {
          retVal = x.viewValue;
        }
      });
    });
    return retVal || '';
  }
}
